import { render, staticRenderFns } from "./EmArchFixedAssetEditModal.vue?vue&type=template&id=65a20fce&scoped=true&"
import script from "./EmArchFixedAssetEditModal.vue?vue&type=script&lang=js&"
export * from "./EmArchFixedAssetEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a20fce",
  null
  
)

export default component.exports